import UntitledIcon from '@payaca/untitled-icons';
import { FC, type JSX } from 'react';
import './GenericUserHelpTip.sass';

interface Props {
  children: any;
  icon?: JSX.Element;
}

export const GenericUserHelpTip: FC<Props> = ({ icon, children }) => (
  <div className={'generic-user-help-tip'}>
    <div>{icon || <UntitledIcon name="info-square.3" />}</div>
    <div>
      <strong>Tip:</strong>
      {children}
    </div>
  </div>
);
